<script setup lang="ts">
import { ModuleProvider } from '@mrbilit/vue-context-provider';
import SupportFlow from './SupportFlow.vue';
import { Support } from '@providers/support';

const props = defineProps<{
    sessionId?: number;
    publicKey?: string;
    center?: boolean;
    source?: string;
}>();
const emit = defineEmits<{ close: []; error: [] }>();
const scrollLock = useScrollLock(
    typeof document === 'undefined' ? null : document.body
);

onMounted(() => (scrollLock.value = true));
onUnmounted(() => (scrollLock.value = false));
</script>
<template>
    <ModuleProvider :value="Support">
        <SupportFlow
            v-bind="props"
            @close="emit('close')"
            @error="emit('error')"
        />
    </ModuleProvider>
</template>
